import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../Services/authentication/authentication.service';
import { ModalService } from '../../../Services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../../Services/analytics/analytics.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnDestroy {

  @Input() type: string;
  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  public currentAvatarImg: any = this.authService.getUserAvatar().image_url;
  private avatarSubscriber;
  public loading = false;

  constructor(private authService: AuthenticationService,
    private modalService: ModalService,
    public translate: TranslateService,
    private analytics: AnalyticsService) { }

  ngOnInit() {
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    };
  }

  public removeModal() {
    this.modalService.destroy();
  }

  onSubmit() {
    if (!this.previewUrl) {
      return;
    }
    const formData = new FormData();
    if (this.type === 'avatar') {
      formData.append('avatar', this.fileData);
      this.initAvatarService(formData);
    }
  }

  initAvatarService(formData) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.avatarSubscriber = this.authService.changeUserAvtar(formData).subscribe(
      (response: any) => {
        this.analytics.logEvent('account_avatar_changed');
        this.loading = false;
        this.removeModal();
      },
      error => {
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    if (this.avatarSubscriber) {
      this.avatarSubscriber.unsubscribe();
    }
  }

}
